import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Input,
  Label,
  FormGroup,
  CustomInput,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import CustomSelect from "../../../../helpers/ui/CustomSelect";

import { Link, useHistory, Redirect } from "react-router-dom";
import { withRouter } from "react-router";

import apiResponse from "../../../../services/apiResponse";

import UpdateBloc from "./Blocs/UpdateBloc";

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear(),
    years = [];
  startYear = startYear || 1980;
  while (startYear <= currentYear) {
    var newObj = {};
    var year = startYear++;
    newObj["label"] = year;
    newObj["value"] = year;
    years.push(newObj);
  }
  return years;
};

class IndexView extends Component {
  updateBloc = new UpdateBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      rankOptions: [],
      yearOptions: createYearOption(new Date().getFullYear() - 30),
    };
  }

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];

      return newObj;
    });
  };

  submitData = async () => {
    await this.updateBloc.fetchUpdate(this.state.dataForm);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        uuid: this.state.dataForm.salary_uuid,
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.updateBloc.updateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.updateBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)
            this.setState({
              dataForm: response,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    const queryParams = new URLSearchParams(this.props.location.search);
    this.updateBloc.fetchDetail({ uuid: queryParams.get("uuid") });

    this.updateBloc.rankListChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              rankOptions: this.reformatOptions(
                response.result,
                "rank_name",
                "rank_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.updateBloc.fetchRank({ limit: 100 });
  }

  componentWillUnmount() {
    this.updateBloc.updateChannel.unsubscribe();
    this.updateBloc.detailChannel.unsubscribe();
    this.updateBloc.rankListChannel.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>Edit Gaji Pokok</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <label
                        htmlFor="rank_name"
                        className="col-md-3 col-form-label"
                      >
                        Pilih Pangkat PPPK{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <CustomSelect
                          name="salary_rank_uuid"
                          errorMessage="Pilih Pangkat"
                          options={this.state.rankOptions}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Pangkat"
                          defaultValue={this.state.dataForm.salary_rank_uuid}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="salary_years_of_work"
                        className="col-md-3 col-form-label"
                      >
                        Masa Kerja (Tahun){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="2">
                        <AvField
                          name="salary_years_of_work"
                          placeholder="Masa Kerja..."
                          type="number"
                          errorMessage="Masukkan Masa Kerja"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="salary_years_of_work"
                          value={this.state.dataForm.salary_years_of_work}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="salary_value"
                        className="col-md-3 col-form-label"
                      >
                        Gaji Pokok <span className="text-danger">*</span>
                      </label>
                      <Col md="2">
                        <AvField
                          name="salary_value"
                          placeholder="Gaji Pokok..."
                          type="number"
                          errorMessage="Masukkan Gaji Pokok"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="salary_value"
                          value={this.state.dataForm.salary_value}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tahun <span className="text-danger">*</span>
                      </label>
                      <Col md="2">
                        <CustomSelect
                          name="salary_year_active"
                          errorMessage="Pilih Tahun"
                          options={this.state.yearOptions}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Tahun"
                          defaultValue={this.state.dataForm.salary_year_active}
                          value={this.state.dataForm.salary_year_active}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="salary_pp_name"
                        className="col-md-3 col-form-label"
                      >
                        Peraturan Pemerintah{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="8">
                        <AvField
                          name="salary_pp_name"
                          placeholder="Peraturan Pemerintah..."
                          type="text"
                          errorMessage="Masukkan Peraturan Pemerintah"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="salary_pp_name"
                          value={this.state.dataForm.salary_pp_name}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="?">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/master/gaji_pokok_pppk.html?" />
        ) : null}
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
